module.exports = __webpack_public_path__ + "img/Pic_Services-1.6648c3f0.jpg";